import { name } from '../symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaMasterPageConfig } from '../types'
import type {
	BrowserWindow,
	TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import {
	BrowserWindowSymbol,
	MasterPageFeatureConfigSymbol,
	CurrentRouteInfoSymbol,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type { ICurrentRouteInfo, IUrlHistoryManager } from 'feature-router'
import { UrlHistoryManagerSymbol } from 'feature-router'
import type { TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { name as tpaCommonsName } from 'feature-tpa-commons'

export type SiteInfoResponse = {
	baseUrl: string
	pageTitle: string
	pageTitleOnly: string
	referer: string
	siteDescription: string
	siteKeywords: string
	url: string
}

export const SiteInfoHandler = withDependencies(
	[
		UrlHistoryManagerSymbol,
		CurrentRouteInfoSymbol,
		named(MasterPageFeatureConfigSymbol, name),
		named(SiteFeatureConfigSymbol, tpaCommonsName),
		BrowserWindowSymbol,
	],
	(
		urlHistoryManager: IUrlHistoryManager,
		currentRouteInfo: ICurrentRouteInfo,
		{ pagesData }: TpaMasterPageConfig,
		{ externalBaseUrl }: TpaCommonsSiteConfig,
		window: BrowserWindow
	): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				siteInfo(): SiteInfoResponse {
					const { pageId } = currentRouteInfo.getCurrentRouteInfo()!
					const { href } = urlHistoryManager.getParsedUrl()
					const { siteDescription, siteKeywords, title } = pagesData[pageId]
					return {
						siteDescription,
						siteKeywords,
						baseUrl: externalBaseUrl,
						pageTitle: window!.document.title,
						pageTitleOnly: title,
						referer: window!.document.referrer,
						url: href,
					}
				},
			}
		},
	})
)
